export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4766.5e14a596.jpg";